<template>
    <div
        class="google-map search btn"
        :class="{
            [mapTheme]: true,
            'hide-layout': !showMobileGridToggle,
            'hide-map-area-button': hideMapAreaButton
        }"
        :style="css"
        v-if="!hideMapArea && (!hideMapAreaButton || showLayoutButton)"
    >
        <span @click="click" v-if="!hideMapAreaButton">{{
            text || $t('redoSearchOnMapArea')
        }}</span>
        <span
            @click="switchLayout(layoutToShow)"
            v-if="showLayoutButton"
            class="toggle"
        >
            <span class="line" v-if="!hideMapAreaButton"></span>
            <i class="iconfont icon-grid-v1"></i>
            <span class="layout">{{ layoutToShow }}</span></span>
    </div>
</template>

<script>
import { mapState, mapActions } from '@/store/helpers';

import Base from './base';
import {
    MAP_CHANGE_MUTATION,
    LAYOUT_UPDATE_MUTATION
} from '@/components/search-result/_store/types';

export default {
    i18next: {
        ns: 'map'
    },
    inject: {
        hideMapArea: {
            // form md-search
            default: false
        },
        searchModuleType: {
            default: ''
        },
        mapTheme: {
            type: String,
            default: ''
        }
    },
    mixins: [Base],
    props: {
        css: {
            type: [String, Object],
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapState({
            "mapCondition": "mapCondition",
            "layout": "layout"
        }),
        
        isMobileSize() {
            return this.platform.isMobile
        },
        showMobileGridToggle({ searchModuleType }) {
            return !searchModuleType;
        },
        isChecked() {
            return this.mapCondition.mapSearch;
        },
        layoutToShow() {
            if (this.layout === 'map') {
                return 'grid';
            }
            return 'map';
        },
        hideMapAreaButton({ mapCondition }) {
            return !!mapCondition?.mapRadius;
        },
        showLayoutButton({ isMobileSize, mapTheme, showMobileGridToggle }) {
            return (
                isMobileSize && mapTheme === 'broker' && showMobileGridToggle
            );
        }
    },
    methods: {
        ...mapActions({
            "mapChangeMutation": MAP_CHANGE_MUTATION,
            "layoutUpdateMutation": LAYOUT_UPDATE_MUTATION
        }),
        switchLayout(layout) {
            this.layoutUpdateMutation({
                layout: layout === 'map' ? 'map' : 'normal',
                isMobile: this.isMobileSize
            });
        },
        
        handler() {
            this.mapChangeMutation({
                mapSearch: !this.isChecked
            });
            this.$EventBus.$emit('siteTrack', {
                action: 'mapsearch',
                trackType: 'map-event',
                ele: this.$el
            });
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.google-map.map-tool.search {
    align-items: center;
    padding: 11px 16px;
    background-color: white;
    font-size: 14px;
    color: #797e8b;
    border-radius: 3px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    font-family: var(--font-normal);
    &.broker{
        display: flex;
        padding: 12px 20px;
        width: 250px;
        border-radius: 22px !important;
        justify-content: center;
        box-shadow: 0 4px 10px 3px rgba(0, 10, 30, 0.1);
        span {
            @include media-600 {
                color: #191919;
            }
            color: var(--g-btn-background);
            font-size: 14px;
            font-family: var(--font-medium);
            white-space: nowrap;
        }
    }
    &.layout1 {
        color: var(--g-primary-color);
        background-color: var(--g-bg-color);
        box-shadow: 0 10px 15px 0 rgba(170, 186, 218, 0.1);
    }
    .toggle {
        margin-left: 12px;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        .line {
            display: inline-block;
            height: 20px;
            width: 1px;
            background: #dadada;
        }
        .iconfont {
            margin-left: 12px;
            margin-right: 10px;
            color: #191919;
        }
        .layout{
            text-transform: capitalize;
        }
    }
    &.hide-map-area-button {
        width: auto;
        .toggle {
            margin-left: 0;
        }
        .icon-grid-v1 {
            margin: 0 10px 0 0;
        }
    }
}
</style>
